import React from 'react';
import './css/global.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from './components/User/LoginPage';
import LogoutPage from './components/User/LogoutPage';
import ChatPage from './components/ChatPage';
import AnalysisPage from './components/AnalysisPage';
import HowToUse from './components/HowToUse';
import DailyReportList from './components/daily_report/DailyReportList';
import InsightNote from './components/InsightNote';
import './App.css';
import DailyReport from './components/daily_report/DailyReport';
import TermOfUse from './components/term_of_use/TermOfUse';
import ChangePassword from './components/User/ChangePassword';
import Register from './components/User/Register';
import ActivateAccount from './components/User/ActivateAccount';
import PasswordReset from './components/User/PasswordReset';
import PasswordResetDone from './components/User/PasswordResetDone';
import LandingPage from './components/landing_page/LandingPage';
import PromptListPage from './components/prompts/PromptListPage';
import HelpListPage from './components/helps/HelpListPage';
import { HelmetProvider } from 'react-helmet-async';
import PaymentPage from './components/payment/PaymentPage';
import PromptDetailPage from './components/prompts/PromptDetailPage';
import HelpDetailPage from './components/helps/HelpDetailPage';
import { Widget } from './components/graph/Widget';
import Pricing from "./components/price/pricing";
// import Storying from "./components/story/storying";

import { UserSettingsProvider } from './context/UserSettingsContext';
import { DashboardProvider } from './context/DashboardContext';
import MyDashboard from './components/MyDashboard/MyDashboard';
import { useEffect } from 'react';
import AnalyticsTracker from './AnalyticsTracker';
import DashboardPage from './components/dashboard/DashbaordPage';
import Research from './components/research/Research';
import { UserProvider } from './components/User/UserContext';

function App() {
  useEffect(() => {
    const isMac = /Mac/i.test(navigator.platform);
    if (isMac) {
      document.body.classList.add("mac");
    }
    const isWindows = /Win/i.test(navigator.platform);
    if (isWindows) {
      document.body.classList.add("windows");
    }
  }, []);

  return (
    <HelmetProvider>
      <UserProvider>
        <DashboardProvider>
          <UserSettingsProvider>
              <Router>
                <AnalyticsTracker />
                <Routes>
                  <Route path="/" element={<LandingPage />} />
                  <Route path="/prompts" element={<PromptListPage />} />
                  <Route path="/helps" element={<HelpListPage />} />
                  {/* <Route path="/pricing" element={<Pricing />} /> */}
                  {/* <Route path="/storying" element={<Storying />} /> */} 
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/logout" element={<LogoutPage />} />
                  <Route path="/register" element={<Register />} />
                  {/* <Route path="/payment" element={<PaymentPage />} /> */}
                  <Route path="/activate/:uid/:token" element={<ActivateAccount />} />
                  <Route path="/chat/:chatId?" element={<ChatPage />} />
                  <Route path="/change-password" element={<ChangePassword />} />
                  <Route path="/password-reset" element={<PasswordReset />} />
                  <Route path="/password-reset-done/:uid/:token" element={<PasswordResetDone />} />
                  <Route path="/analysis" element={<AnalysisPage />} />
                  <Route path="/analysis/:secCode/:page" element={<AnalysisPage />} />
                  <Route path="/research/:reportId?" element={<Research />} />
                  <Route path="/how-to-use" element={<HowToUse />} />
                  <Route path="/daily-report-list" element={<DailyReportList />} />
                  <Route path="/daily-report/:secCode/:date" element={<DailyReport />} />
                  <Route path="/insight-note" element={<InsightNote />} />
                  <Route path="/insight-board" element={<MyDashboard />} />
                  <Route path="/term-of-use" element={<TermOfUse />} />
                  <Route path="/prompts/:id" element={<PromptDetailPage />} />
                  <Route path="/helps/:id" element={<HelpDetailPage />} />
                  <Route path="/widget" element={<Widget />} />
                </Routes>
              </Router>
          </UserSettingsProvider>
        </DashboardProvider>
      </UserProvider>
    </HelmetProvider>
  );
}
export default App;
